import { createApp } from 'vue'
import { configuration } from '@dpgradio/creative'
import './style.css'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router'

const initialize = async () => {
  try {
    await configuration.retrieveConfigForDetectedStation()
  } catch (error) {
    alert(`
      Could not load configuration. Did you provide a station? (through the URL parameter 'stationId')

      ${error}
    `)
  }

  const router = createRouter({
    history: createWebHistory(),
    routes: [
      { path: '/', component: () => import('./pages/Map.vue') },
      { path: '/create', component: () => import('./pages/Create.vue') },
    ],
  })

  const app = createApp(App)
  app.use(router)
  app.mount('#app')
}

initialize()
